import React from 'react';
import { cn } from '../../src/lib/utils';
type EyebrowProps = {
  children: React.ReactNode;
  className?: string;
  withDot?: boolean;
  tone?: 'light' | 'dark';
};
export function Eyebrow({
  children,
  className,
  withDot = true,
  tone = 'light'
}: EyebrowProps) {
  return <p className={cn('inline-flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.09em]', tone === 'dark' ? 'text-night-muted' : 'text-text-tertiary', className)} data-id="element-1280" data-mp="2e8yvm7srjfsu">
      {withDot ? <span aria-hidden="true" className={cn('h-1.5 w-1.5 rounded-full', tone === 'dark' ? 'bg-violet' : 'bg-lime')} data-id="element-1281" data-mp="2ny0a1tjntp4p" /> : null}
      {children}
    </p>;
}